import Vue from 'vue'
import Router from 'vue-router'
import pagesConfig from './pages.config.json'
import * as pagesComponents from './pages.components'

Vue.use(Router)

/*
 * 解决Vue-Router 3.0以上版本报错问题
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const createAnRoute = (item) => {
  const anRoute = {
    path: item.path,
    name: item.name || '',
    meta: item.meta || '',
    redirect: item.redirect || '',
    component: pagesComponents[item.component],
  }
  if (item.children && item.children.length > 0) {
    anRoute.children = item.children.map((child) => createAnRoute(child))
  }
  return anRoute
}

const registerRoute = (config) => {
  const route = []
  config.forEach((page) => {
    route.push(createAnRoute(page))
  })
  return route
}

const routes = registerRoute(pagesConfig)
routes.push({
  path: '*',
  redirect: '/404',
})
console.log('routes', routes)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes,
})
